import useTranslation from 'next-translate/useTranslation';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

// Lib
import userTimeFormat from '@/lib/user/timeFormat';

dayjs.extend(customParseFormat);

const useFormatDayOfWeek = () => {
    const { t } = useTranslation('commons');

    const formatDayOfWeek = (dayAndTime, timeFormat) => {
        if (!dayAndTime || !dayAndTime.day) return '';

        const { day, hour } = dayAndTime;

        const translatedDay = t(`days.${day.toLowerCase()}`);

        if (hour) {
            return t('dayOfWeek', {
                day: translatedDay,
                hour:
                    timeFormat === '12'
                        ? dayjs(hour, userTimeFormat['24_hour_minutes']).format(
                              userTimeFormat['12_hour_minutes']
                          )
                        : hour
            });
        }

        return translatedDay;
    };

    return { formatDayOfWeek };
};

export default useFormatDayOfWeek;
